<template>
  <div class="mobile clearfix">
    <MobileHeader />

    <div class="container">
      <div class="row">
        <button class="mybutton" @click="goto('HospitalSummedup?channelCode=inpatientDepartment')">住院科室</button>
      </div>
      <div class="row">
        <button class="mybutton" @click="goto('HospitalSummedup?channelCode=outpatientDepartment')">门诊科室</button>
      </div>
      <div class="row">
        <button class="mybutton" @click="goto('HospitalSummedup?channelCode=auxiliaryDepartment')">辅诊科室</button>
      </div>
      <div class="row">
        &nbsp;
      </div>
      <div class="row">
        &nbsp;
      </div>
      <div class="row">
        &nbsp;
      </div>
      <div class="row">
        &nbsp;
      </div>
    </div>

    <MobileFooter />
  </div>
</template>

<script>
import MobileHeader from './MobileHeader.vue'
import MobileFooter from "./MobileFooter";
import _http from "../httpService";

export default {
  name: "MobileKesdh",
  components: {
    MobileHeader,
    MobileFooter
  },
  data() {
    return {
    }
  },

  methods: {
    goto(url) {
      this.$router.push({ path: url });
    }
  }
}
</script>

<style>
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
}

.mybutton {
  width: 250px;
  height: 100px;
  font-size: 30px;
  background-color: #0eb4b6;
  border-radius: 10px;
  color: white;
  border: none;
  box-shadow: 10px 10px 10px gray;
}
</style>